import type { SVGProps } from 'react';
const SvgPowerInput = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#power_input_svg__a)">
      <path
        fill="currentColor"
        d="M2 9v2h19V9H2Zm0 6h5v-2H2v2Zm7 0h5v-2H9v2Zm7 0h5v-2h-5v2Z"
      />
    </g>
    <defs>
      <clipPath id="power_input_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPowerInput;
